import { ChangeEvent, useEffect, useRef, useState } from "react";
import AdminNavBar from "./AdminNavBar";
import TimesheetNavBar from "./TimesheetNavBar";
import { FetchActiveUsers, User, UserSelect } from "./UserSelect";
import { SelectInstance } from "react-select";

const DeleteTime = () => {
	interface Unit {
		id: number;
		unit: string;
		active: boolean;
	}
	interface clockEntry {
		entryID: number[]
		userID: number
		clockIn: string
		clockOut: string
		date: string
		unit: string
		unitID: number
		location: string
		locationID: number
	}
	interface Location {
		active: boolean
		id: number
		long_name: string
		short_name: string
	}
	
	interface Option {
		value: any;
		label: string;
	}

	var userRef = useRef<HTMLSelectElement>(null)
	var dateRef = useRef<HTMLSelectElement>(null)
	var selectRef = useRef<SelectInstance<Option | null>>(null)

	const clockInRefs = useRef<Map<number, HTMLInputElement>>(new Map());
	const clockOutRefs = useRef<Map<number, HTMLInputElement>>(new Map());
	const unitRefs = useRef<Map<number, HTMLSelectElement>>(new Map());
	const locationRefs = useRef<Map<number, HTMLSelectElement>>(new Map());
	const entryDateRef = useRef<Map<number, HTMLInputElement>>(new Map());

	const [isUserSet, setIsUserSet] = useState(false)
	const [users, setUsers] = useState<User[]>([])
	const [selectedUser, setSelectedUser] = useState<User>({ id: 0, first_name: "", middle_name: "", last_name: "", signed_in: false, photo: "", active: false, email: "", password: "", role: "" })
	const [dates, setDates] = useState<string[]>([])
	const [clockEntries, setClockEntries] = useState<clockEntry[]>([])
	const [units, setUnits] = useState<Unit[]>([])
	const [locations, setLocations] = useState<Location[]>([])
	const [msg, setMsg] = useState("")
	var deletedEntryIDs: number[] = []

	const getUnits = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/units")
		if (response) {
			const units = await response.json()
			setUnits(units)
		}
	}

	const getLocations = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/locations")
		if (response) {
			const locations = await response.json()
			setLocations(locations)
		}
	}


	const getClockInRef = (id: number) => {
		const map = clockInRefs.current;
		return (node: HTMLInputElement | null) => {
			if (node) {
				map.set(id, node);
			} else {
				map.delete(id);
			}
		};
	};

	const getClockOutRef = (id: number) => {
		const map = clockOutRefs.current;
		return (node: HTMLInputElement | null) => {
			if (node) {
				map.set(id, node);
			} else {
				map.delete(id);
			}
		};
	};

	const getUnitRef = (id: number) => {
		const map = unitRefs.current;
		return (node: HTMLSelectElement | null) => {
			if (node) {
				map.set(id, node);
			} else {
				map.delete(id);
			}
		};
	};

	const getLocationRef = (id: number) => {
		const map = locationRefs.current;
		return (node: HTMLSelectElement | null) => {
			if (node) {
				map.set(id, node);
			} else {
				map.delete(id);
			}
		};
	};

	const getEntryDateRef = (id: number) => {
		const map = entryDateRef.current;
		return (node: HTMLInputElement | null) => {
			if (node) {
				map.set(id, node);
			} else {
				map.delete(id);
			}
		};
	};

	const getUnitNameByID = (id: number): string => {
		for (var i = 0; i < units.length; i++) {
			if (units[i].id.toString() === id.toString()) {
				return units[i].unit
			}
		}
		return ""
	}

	const getLocationNameByID = (id: string): string => {
		for (var i = 0; i < locations.length; i++) {
			if (locations[i].id.toString() === id) {
				return locations[i].short_name + " - " + locations[i].long_name
			}
		}
		return ""
	}


	useEffect(() => {
		FetchActiveUsers(setUsers)
		getUnits()
		getLocations()
	}, [setUsers])

	// get dates for each user, populate select
	const GetDatesByUser = async () => {
		if (msg) {
			setMsg("")
		}
		setDates([])
		var userID = ""
		if (userRef && userRef.current && userRef.current.value) {
			userID = userRef.current.value
			const response = await fetch(process.env.REACT_APP_API+"/api/dates?user_id="+userID)
			const result = await response.json()
			var dates: string[] = []
			for (var i = 0; i < result.length; i++) {
				dates.push(result[i].substring(0, 10))
			}
			setDates(dates)
			setClockEntries([])
		}
	}

	const addDeletedIds = () => {
		return (event: ChangeEvent<HTMLInputElement>) => {
			var deletedIds = event.target.value.split(",")
			if (event.target.checked) {
				console.log("deleting entry with ids: " + deletedIds[0] + " and " + deletedIds[1])
				deletedEntryIDs.push(parseInt(deletedIds[0]))
				deletedEntryIDs.push(parseInt(deletedIds[1]))
			} else {
				// if unchecked, add back to clock entries - need to refetch data for that date
				console.log("unchecking entry with ids: " + deletedIds[0] + " and " + deletedIds[1])
				deletedEntryIDs = deletedEntryIDs.filter(id => id !== parseInt(deletedIds[0]) && id !== parseInt(deletedIds[1]))
			}
			console.log("current deleted entry ids: " + deletedEntryIDs)
		}
	}
	

	const GetTimeEntriesByDate = async () => {
		setClockEntries([])
		var userID = ""
		if (userRef && userRef.current) {
			userID = userRef.current.value
		}
		var date = ""
		if (dateRef && dateRef.current) {
			date = dateRef.current.value
		}

		// once date is submitted, get clock entries for that date
		//TODO: Units needs to be a select, with the default unit selected

		const response = await fetch(process.env.REACT_APP_API+"/api/clockEntries?user_id=" + userID + "&date=" + date)
		const result = await response.json()

		var length:number = 0
		if (result.length % 2 === 1) {
			length = result.length - 1
			var newEntry = {id: result[length].id, user_id: result[length].user_id, event: "sign_out", event_date: result[length].event_date, event_time: result[length].event_time, location: result[length].location, unit: result[length].unit}
			result.push(newEntry)
			length++
		} else {
			length = result.length
		}

		var clockEntries: clockEntry[] = []
		for (var i = 0; i < length; i+=2) {
			var entry:clockEntry = {
				entryID: [result[i].id, result[i + 1].id],
				userID: result[i].user_id,
				clockIn: result[i].event_time.substring(11).split(".")[0].replace("Z", ""),
				clockOut: result[i + 1].event_time.substring(11).split(".")[0].replace("Z", ""),
				date: result[i].event_date.substring(0, 10),
				unit: result[i].unit,
				unitID: result[i].unit,
				location: result[i].location,
				locationID: result[i].location
			}
			clockEntries.push(entry)
		}

		setClockEntries(clockEntries)
	}

	const  submitData = async () => {

		try {
			const response = await fetch(process.env.REACT_APP_API+"/api/deleteTime", {
				method: "DELETE",
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify(deletedEntryIDs)
			})
			if (response.status === 200) {
				setMsg("Timesheet(s) deleted  successfully")
				// clear values
				if (userRef && userRef.current) {
					userRef.current.value = ""
				}
				if (dateRef && dateRef.current) {
					dateRef.current.value = ""
				}
				setIsUserSet(false)
				if (selectRef && selectRef.current) {
					selectRef.current.setValue({ value: 0, label: "" }, "deselect-option")
				}
			} else {
				setMsg("Error deleting timesheet")
			}
		} catch (err) {
			console.log(err)
		}
	}

	return (
		<div className="resilire">
			<AdminNavBar />
			<TimesheetNavBar />
			<h3>Delete Timesheet</h3>
			<UserSelect isVisible={isUserSet} setIsVisible={setIsUserSet} setUsers={setUsers} users={users} setSelectedUser={setSelectedUser} ref={userRef} onChange={GetDatesByUser} selectRef={selectRef}/>
			{isUserSet && (
				<div className="resilire">
					<label htmlFor="date">Select Date</label>
					<select id="date" name="date" ref={dateRef} onChange={GetTimeEntriesByDate}>
						<option value=""></option>
						{
							dates.map((date) => (
								<option value={date} key={date}>{date}</option>
							))
						}
					</select>
					<br />

					{clockEntries && clockEntries.map((entry, index) => (

						<div className="resilire" key={entry.entryID[0]}>
							<table>
								<thead>
									<tr>
										<th>Date</th>
										<th>Unit</th>
										<th>Location</th>
										<th>Clock In</th>
										<th>Clock Out</th>
										<th>Delete</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{entry.date}</td>
										<td>{getUnitNameByID(entry.unitID)}</td>
										<td>{getLocationNameByID(entry.location)}</td>
										<td>{entry.clockIn}</td>
										<td>{entry.clockOut}</td>
										<td style={{textAlign:'center'}}><input type="checkbox" id={"delete"+index} name={"delete"+index} value={entry.entryID[0].toString() + "," + entry.entryID[1].toString()} onChange={addDeletedIds()} /></td>
										
									</tr>
								</tbody>
							</table>
							<br />
						</div>

					))
					}
					{dateRef && dateRef.current && dateRef.current.value !== "" && (
						<div className="resilire">
							<button id="submit" name="submit" onClick={submitData}>Submit</button>
						</div>
					)}

				</div>
			)}

			{msg && (

				<div>
					{msg}
				</div>
			)}
		</div>
	)
}

export default DeleteTime;
